import { GridRow } from '@mytours/components'
import React, { ComponentProps } from 'react'
import classNames from 'classnames'

import './styles.less'

interface Props extends ComponentProps<typeof GridRow> {
	label?: React.ReactNode
	value?: React.ReactNode
	labelId?: string
	'data-cy': `settings-row-${string}`
}

const SettingsRow: React.FC<Props> = ({ label, value, children, labelId, className, ...props }) => (
	<GridRow {...props} className={classNames('settings-row', className)}>
		<div className="side label" id={labelId}>
			{label}
		</div>
		{children}
		<div className="side value" aria-labelledby={labelId}>
			{value}
		</div>
	</GridRow>
)

export default SettingsRow
